var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"linear-title"},[_c('div',{staticClass:"linear-bg"},[_c('img',{style:({ width: _vm.LINEAR_TITLT_MAP[_vm.bg].width + 'px' }),attrs:{"src":_vm.LINEAR_TITLT_MAP[_vm.bg].url,"alt":""}})]),_c('div',{staticClass:"linear-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }